import React, { useEffect, useState } from "react";
import moment from "moment";
import { MARGIN_HISTORY, SOLD_STOCKS } from "@/services/productService";
import { useLazyQuery } from "@apollo/client";

import TableComponent from "./Table";

import { MERCHANT_ID } from "@/constants/env";
import { getDateRangeIncludingLastWeekStartDay } from "./helper";

const PERIOD = 24 * 3600;

const TableLayout = ({ store, dateRange, refetchVolume }) => {
  const [marginHistory, setMarginHistory] = useState([]);
  const [soldStocks, setSoldStocks] = useState([]);

  const [hasLoadedMargin, setHasLoadedMargin] = useState(false);
  const [hasLoadedSoldStocks, setHasLoadedSoldStocks] = useState(false);

  const [getMarginHistory] = useLazyQuery(MARGIN_HISTORY, {
    onCompleted: (data) => {
      setMarginHistory(data.margin_history);
      setHasLoadedMargin(true);
    },
    onError: () => setHasLoadedMargin(true),
    fetchPolicy: "no-cache",
  });

  const [getSoldStocks] = useLazyQuery(SOLD_STOCKS, {
    onCompleted: (data) => {
      setSoldStocks(data.main_data);
      setHasLoadedSoldStocks(true);
    },
    onError: () => setHasLoadedSoldStocks(true),
    fetchPolicy: "no-cache",
  });

  const getProductIds = () => {
    return store.products?.map((item) => item.id);
  };

  const refetchQueries = () => {
    const range = getDateRangeIncludingLastWeekStartDay(dateRange);
    setHasLoadedMargin(false);
    setHasLoadedSoldStocks(false);
    getMarginHistory({
      context: {
        headers: {
          merchantId: MERCHANT_ID,
          storeId: store.id,
        },
      },
      variables: {
        product_ids: getProductIds(),
        from: moment(dateRange[0]).toISOString().replace("Z", ""),
        to: moment(dateRange[1]).toISOString().replace("Z", ""),
      },
    });

    getSoldStocks({
      context: {
        headers: {
          merchantId: MERCHANT_ID,
          storeId: store.id,
        },
      },
      variables: {
        product_ids: getProductIds(),
        period: PERIOD,
        from: moment(range.from).toISOString().replace("Z", ""),
        to: moment(range.to).toISOString().replace("Z", ""),
        fromCompare: moment(range.from).toISOString().replace("Z", ""),
        toCompare: moment(range.to).toISOString().replace("Z", ""),
      },
    });
  };

  useEffect(() => {
    refetchQueries();
  }, [store?.id, dateRange, refetchVolume]);

  return (
    <div>
      <TableComponent
        dateRange={dateRange}
        products={store.products}
        loading={!hasLoadedMargin || !hasLoadedSoldStocks}
        marginHistory={marginHistory}
        soldStocks={soldStocks}
      />
    </div>
  );
};

export default TableLayout;
